import { RecordingAction, RecordingState } from "./types";
import { API_AUTH_RESET }                  from "../../constants/API";
import { initialState }                    from "./initialState";

const reducer = (state: RecordingState = initialState, action: RecordingAction) => {

  switch (action.type) {
    case('setStartPoint'): {
      const {startPoint} = action;
      const {endPoint} = state;

      return {
        ...state,
        startPoint: startPoint,
        endPoint: endPoint
      };
    }

    case('setEndPoint'): {
      const {startPoint} = state;
      const {endPoint, reverse} = action;

      return {
        ...state,
        endPoint: reverse ? startPoint : endPoint,
        startPoint: reverse ? endPoint : startPoint
      };
    }

    case('resetExportPoints') :
      return {
        ...state,
        startPoint: null,
        endPoint: null
      };

    case('changeExportsMode'):
      return {
        ...state,
        mode: action.mode
      };

    case('setAvilist'):
      return {
        ...state,
        avilist: action.avilist
      };

    case('setAVIId'):
      return {
        ...state,
        shareAviID: action.aviId
      };

    case('closeShareAviId'):
      return {
        ...state,
        shareAviID: null
      };

    case API_AUTH_RESET :
      return {
        ...initialState
      };

    default:
      return {...state}
  }
};

export default reducer